var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showPrintContentButton || _vm.showDownloadContentButton
        ? _c("download-content-buttons", {
            attrs: {
              pagePartId: _vm.pagePartId,
              showPrintContentButton: _vm.showPrintContentButton,
              showDownloadContentButton: _vm.showDownloadContentButton
            }
          })
        : _vm._e(),
      _c("div", {
        directives: [
          {
            name: "lazy-container",
            rawName: "v-lazy-container",
            value: { selector: "img[data-src]" },
            expression: "{ selector: 'img[data-src]' }"
          }
        ],
        staticClass: "content-only-block",
        domProps: { innerHTML: _vm._s(_vm.content) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }